import styled from '@emotion/styled';

export const Content = styled.div`
    @media screen {
        padding: 80px 150px;
        .mb-4 {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 32px;
            line-height: 37px;
            text-align: center;
            padding-bottom : 80px;
        }
        .mb-5 {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 28px;
            line-height: 37px;
            text-align: left;
        }
        p {
            font-family: Source Sans Pro;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            line-height: 24px;
        }

        .btn-primary {
            margin-top : 20px;
        }

        .container-dropzone {

        }
       

        .dropzone {
            border: 1px dashed black;
            background-color : white;
            height : 150px;
            margin-bottom : 50px;
        }

        .text-center{
            text-align: center;
        }

        .previewObject{
            height : 200px;
        }

        .text-danger{
            text-align: right!important;
        }

        background-color : #F7F7F7;
            
        `;
